import {CustomerResponseBodyV2} from '../types';

export const legalCustomerResponseMock: CustomerResponseBodyV2 = {
  id: 'f05b8953-985a-49d8-8e04-8e309b61524c',
  discriminator: 'BUSINESS',
  source: null,
  foundingPerson: null,
  businessInfo: {
    id: '62a2a9a8-c930-4639-aace-d02e86913606',
    businessInfo: {
      countryOfRegistrationCode: 'CZE',
      registrationNumber: '05225108',
      vatNumber: 'CZ9504241296',
      tradeName: 'Jan Ehrlich',
      fileNumber: 'Zapsán v živnostenském rejstříku příslušného úřadu: Úřad městské části Praha 4',
    },
    address: null,
  },
  contacts: [
    {
      id: 'ca14fa84-809b-4b2a-a0d9-842c9731d41f',
      firstName: 'Jan',
      lastName: 'Ehrlich',
      middleName: null,
      titleBefore: null,
      titleAfter: null,
      genderKey: null,
      roles: null,
      citizenshipCode: null,
      birthdate: null,
      personalIdentifier: null,
      preferredLanguage: null,
      phoneNumbers: [
        {
          type: null,
          countryCode: 'CZE',
          prefix: '+420',
          number: '739564329',
        },
      ],
      emails: [
        {
          type: null,
          email: 'honza.ehrlich@gmail.com',
        },
      ],
      identityCards: [],
      permanentAddress: null,
    },
  ],
  primaryContactId: 'ca14fa84-809b-4b2a-a0d9-842c9731d41f',
  persons: [
    {
      id: 'ca14fa84-809b-4b2a-a0d9-842c9731d41f',
      firstName: 'Jan',
      lastName: 'Ehrlich',
      middleName: null,
      titleBefore: null,
      titleAfter: null,
      genderKey: null,
      roles: null,
      citizenshipCode: null,
      birthdate: null,
      personalIdentifier: null,
      preferredLanguage: null,
      phoneNumbers: [
        {
          type: null,
          countryCode: 'CZE',
          prefix: '+420',
          number: '739564329',
        },
      ],
      emails: [
        {
          type: null,
          email: 'honza.ehrlich@gmail.com',
        },
      ],
      identityCards: [],
      permanentAddress: null,
    },
  ],
  contractInformation: [
    {
      id: 'f05b8953-985a-49d8-8e04-8e309b61524c',
      permanent: true,
      legalForm: 'LEGAL_ENTITY',
      isDeleted: true,
      person: null,
      businessInfo: {
        id: '62a2a9a8-c930-4639-aace-d02e86913606',
        businessInfo: {
          countryOfRegistrationCode: 'CZE',
          registrationNumber: '05225108',
          vatNumber: 'CZ9504241296',
          tradeName: 'Jan Ehrlich',
          fileNumber:
            'Zapsán v živnostenském rejstříku příslušného úřadu: Úřad městské části Praha 4',
        },
        address: null,
      },
      bankAccounts: [],
      customFieldsPayload: [],
    },
  ],
  addresses: [
    {
      id: '425d462f-e786-4a61-ba80-89909f360de6',
      address: {
        street: 'Kloboučnická 1735/26',
        descriptiveNumber: null,
        orientationNumber: null,
        city: 'Praha 4',
        zip: '14000',
        addressComplement: null,
        country: 'CZE',
        prefix: null,
        district: null,
        state: 'Hlavní město Praha',
        postal: null,
        coordinates: null,
        externalAddressId: null,
      },
      type: null,
      invalid: false,
    },
  ],
  selfEmployed: null,
  selfEmployedBusinessAddress: null,
  selfEmployedBusinessInfoData: null,
  publicId: 'C023784',
  institutions: [],
  customerGroups: [],
  abroadSale: null,
  preferredLocale: null,
};
